<template>
  <div class="content-w">
     <div class="container">
       <ul class="breadcrumb">
          <li class="breadcrumb-item">
              <router-link :to="{name: 'Home'}">Página Principal</router-link>
          </li>
          <li class="breadcrumb-item">
              <span>Orçamento</span>
          </li>
      </ul>
      <div class="element-wrapper pb-2">
        <h3>Orçamento</h3>
      </div>
      <div class="element-box">
        <div class="container-i">
            <div class="row">
              <div class="col-md-3" v-if="tipoOrcamento">
                <div class="sidebar-budget">

                  <form @submit.prevent="busca" autocomplete="off">
                    <div class="element-wrapper">
                    <h6 class="element-header">Tipo de Exame</h6>
                     <div class="form-row align-items-center">
                      <div class="col-md-12">
                        <h5 style="font-weight: bold;">{{tipoOrcamento.name}}</h5>
                        <a @click="$store.dispatch('setTipoOrcamento', null)" class="limpar-link btn btn-light btn-sm btn-block">
                          Trocar

                        </a>
                      </div>
                      <br />
                      <br />
                      <hr>
                      <h6 class="element-header mt-4">Localização</h6>
                      <div class="col-md-12">
                        <label class="mr-sm-2" for="inlineFormCustomSelect">Informe o bairro ou cidade</label>
                        <google-maps-autocomplete placeholder="Endereço" ></google-maps-autocomplete>
                      </div>
                      <br>
                      <div class="col-md-12 mt-3">
                        <label class="mr-sm-2" for="inlineFormCustomSelect">Nome Laboratório</label>
                        <a class="post-box bg-grey list-lab" style="cursor: pointer" @click="showModalUnidades(ub)" v-for="ub in unidadesSelect" :key="ub._id">
                          <div class="post-media">
                            <img :src="`${baseUrl}/redeImagemLogo?q=${ub.nomeRede}`"
                              :onerror="`this.src='${require('@/img/icon-drachei.svg')}'`"
                              class="img-fluid" alt="Brand">
                          </div>
                          <div class="post-content">
                            <h6 class="post-title">
                              {{ub.nomeRede}}
                            </h6>
                            <div class="post-foot">

                              <a class="post-link" style="cursor: pointer" @click="showModalUnidades(ub)"><span>Selecionar</span><i class="os-icon os-icon-arrow-right7"></i></a>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                    </div>
                  </form>
                </div>
              </div>
              <div class="col" v-if="!tipoOrcamento">
                <div class="row">
                  <div class="col-md-4" v-for="vl in tiposOrcamento" :key="vl.id">
                    <div class="card element-box card-border mb-3 text-center" >
                      <div class="card-body text-secondary">
                        <h5 class="card-title">{{vl.title}}</h5>
                        <p class="card-text">{{vl.description}}</p>
                      </div>
                      <div class="card-action">
                        <a href="#" @click="escolherTipoOrcamento(vl)" class="btn btn-primary">Escolher</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <template >
                <div ref="unidadeEndereco" class="col" v-if="!unidade && unidadeSelected">
                  <div class="row">
                    <div class="col-md-4" v-for="unidade in unidadesEndereco" :key="unidade._id">
                      <div class="element-box orcamento-rede-item" >
                        <div clas="d-flex justify-content-between">
                          <div class="img-rede">
                          <img
                          :src="`${baseUrl}/redeImagemLogo?q=${unidade.nomeRede}`"
                          :onerror="`this.src='${require('@/img/icon-drachei.svg')}'`"
                          class="img-fluid" />
                          </div>
                          <div class="info-orcamento-rede">
                            <h5>{{unidade.nomeRede}}</h5>
                            <small>{{getEndereco(unidade)}}</small>
                          </div>
                        </div>
                        <hr>
                        <button type="button" class="btn btn-block btn-outline-primary"
                      @click.stop="escolherRede(unidade)">Escolher</button>
                      </div>
                    </div>
                  </div>


                </div>
                <div ref="unidadeExame" class="col" v-if="unidade">

                  <section class="header-single">
                      <div class="container">
                        <div class="element-box">
                          <div class="row">
                              <div class="col-md-2 text-center">
                                  <div class="avatar-w">
                                      <img alt="" class="img-fluid" :src="`${baseUrl}/redeImagemLogo?q=${unidade.nomeRede}`" :onerror="`this.src='${require('@/img/icon-drachei-alpha.svg')}'`">
                                  </div>
                                  <rate :length="5" :value="unidade.rate" :readonly="true"></rate>
                              </div>
                              <div class="col-md-6">
                                  <h4>{{ unidade.nomeRede }}</h4>
                                  <div class="label"></div>

                                  <div class="dados">
                                      <h6 v-if="unidade.telefone" class="mt-2 mb-2"><i class="ti-mobile"></i> {{ unidade.telefone}}</h6>
                                      <a href="#" class="location"><i class="ti-location-pin"></i> <span>{{ getEndereco(unidade) }}</span></a>
                                  </div>
                                  <br>
                                  <div class="features mb-4">
                                      <a v-if="unidade.agendamento" href="#" class="badge badge-primary mr-sm-2">Agendamento</a>
                                      <a v-if="unidade.delivery" href="#" class="badge badge-primary mr-sm-2">Em Domicílio</a>
                                  </div>
                                  <div class="social">
                                      <a href="#"><i class="os-icon os-icon-twitter"></i></a>
                                      <a href="#"><i class="os-icon os-icon-facebook"></i></a>
                                      <a href="#"><i class="os-icon os-icon-instagram"></i></a>
                                  </div>
                              </div>
                              <div class="col-md-4">
                                  <div class="embed-responsive embed-responsive embed-responsive-16by9">
                                      <iframe class="embed-responsive-item" :src="`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAPS_KEY}&q=${getEndereco(unidade)}`" width="400" height="200" frameborder="0" style="border:0" allowfullscreen></iframe>
                                  </div>
                              </div>
                          </div>
                      </div>
                    </div>
                  </section>

                  <form @submit.prevent="addExame">
                    <div class="element-wrapper">
                      <h6 class="element-header">Exames</h6>
                      <div class="form-desc">
                        Liste todos os exames que você deseja
                      </div>
                      <div class="form-row align-items-center">
                        <div class="col my-1">
                          <label class="mr-sm-2" for="inlineFormCustomSelect">Digite o nome do exame</label>
                          <vue-bootstrap-typeahead
                              :data="exames"
                              ref="laboratorioTh"
                              v-model="nomeExameSearch"
                              :serializer="s => s.nomeExame"
                              placeholder="Digite o exame"
                              @hit="addExame($event)"
                            >
                          </vue-bootstrap-typeahead>
                          <small>Observe se o nome do exame escolhido esta de acordo com o pedido médico</small>
                        </div>
                      </div>
                        <div class="form-row">
                        <div class="table-responsive">
                          <table class="table table-lightborder">
                            <thead>
                              <tr>
                                <th class="text-center">Descrição do exame</th>
                                <th class="text-center">Valor Particular</th>
                                <th class="text-center">Valor Dr.Achei</th>
                                <th class="text-center">Valor Dr.Achei Card</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(exame, i) in filtroExames" :key="exame._id">
                                <td>{{exame.nomeExame}}</td>
                                <td class="text-right">{{(exame.valorParticular||0.0) | money}}</td>
                                <td class="text-right">{{(exame.valorDrAchei||0.0) | money}}</td>
                                <td class="text-right">{{(exame.valorSinSaude||0.0) | money}}</td>
                                <td class="text-right"><a class="btn btn-sm btn-danger" href="" @click.prevent="filtroExames.splice(i, 1)" ><i class="os-icon os-icon-ui-15"></i></a></td>
                              </tr>
                            </tbody>
                            <tfoot>
                              <tr>
                                <td class="text-right">
                                  <b>Total por Forma de pagamento:</b>
                                </td>
                                <td class="text-right">{{subTotalValorParticular | money}}</td>
                                <td class="text-right">{{subTotalValorDrAchei | money}}</td>
                                <td class="text-right">{{subTotalValorSinSaude | money}}</td>
                                <td></td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </div>
                  </form>

                  <div class="col">
                    <div class="text-center">
                      <button type="button" class="btn btn-primary btn-lg"
                        :disabled="filtroExames.length == 0"
                        @click="btnCompra">Adquirir</button>
                    </div>
                  </div>
                </div>
              </template>
            </div>
        </div>

      </div>
      <slick-unidade></slick-unidade>
     </div>

     <div aria-hidden="true" class="onboarding-modal modal fade animated" :id="`onboardingFeaturesModal`" role="dialog" tabindex="-1">
        <div class="modal-dialog modal-centered" role="document">
          <div class="modal-content text-center">
              <button aria-label="Close" class="close" data-dismiss="modal" type="button"><span class="close-label">Fechar</span><span class="os-icon os-icon-close"></span></button>

              <div class="onboarding-content with-gradient">
                  <strong>Confira que o(s) nome(s) do(s) exame(s) escolhido(s) esta(ão) de acordo com o pedido médico!</strong>
              <div class="row">
                <div class="col">
                  <button type="button" @click.stop="comprar()" class="btn btn-primary">
                    Confirmar
                    </button>
                    <button type="button" @click.stop="comprar()" class="btn btn-secondary">
                    Cancelar
                    </button>
                </div>
              </div>
              </div>
          </div>
        </div>
      </div>

  </div>

</template>

<script>
  import eventBus from '@/event-bus'
  import OrcamentoItem from '@/components/pages/orcamento/OrcamentoItem'
  import GoogleMapsAutocomplete from '@/components/shared/GoogleMapsAutocomplete'
  import SlickUnidade from '@/components/shared/SlickUnidades'
  import _ from 'lodash'
  import http from 'axios'

  export default {
    mounted () {
      this.$store.dispatch('setListOrcamento', [])
      this.$store.dispatch('setTipoOrcamento', null)
      eventBus.$on('loginSuccess', this.irParaPagamento)
      eventBus.$on('onSetPlace', this.loadUnidades)
    },
    components: {
      'orcamento-item': OrcamentoItem,
      GoogleMapsAutocomplete,
      SlickUnidade
    },
    computed: {
      baseUrl () {
        return http.defaults.baseURL
      },
      listOrcamento () {
        return this.$store.getters.listOrcamento
      },
      sizeTotalOrcamento () {
        return this.$store.getters.sizeTotalOrcamento
      },
      pageCountOrcamento () {
        return this.$store.getters.pageCountOrcamento
      },
      subTotalValorParticular () {
        if (this.filtroExames.length === 0) return 0
        return this.filtroExames.map(exame => exame.valorParticular).reduce((a, value) => a + value, 0)
      },
      subTotalValorDrAchei () {
        if (this.filtroExames.length === 0) return 0
        return this.filtroExames.map(exame => exame.valorDrAchei).reduce((a, value) => a + value, 0)
      },
      subTotalValorSinSaude () {
        if (this.filtroExames.length === 0) return 0
        return this.filtroExames.map(exame => exame.valorSinSaude).reduce((a, value) => a + value, 0)
      },
      queryParam () {
        let params = {}
        params.servico = 'Exame'
        params.idRede = this.unidade._id
        if (this.filtroExames.length > 0) {
          params.exames = this.filtroExames.map(exame => exame._id)
        }
        return params
      },
      tipoOrcamento () {
        return this.$store.getters.tipoOrcamento
      }
    },

    data () {
      return {
        GOOGLE_MAPS_KEY: 'AIzaSyDkKIKv_5RypDjSm7Fy20vldKy_BhYyQYI',
        page: 1,
        pageSize: 10,
        exame: null,
        nomeExameSearch: '',
        exames: [],
        filtroExames: [],
        nomeUnidadeSearch: '',
        unidades: [],
        unidadesSelect: [],
        unidadesEndereco: [],
        unidade: null,
        unidadeSelected: null,
        ordenacao: 'Prestador',
        outrosServicos: {
          'exame': [
            'Agendamento', 'Coleta em Domicílio', 'Pagamento Online', 'Pagamento Ato'
          ]
        },
        outroServico: {
          'Agendamento': false,
          'Delivery': false,
          'Pagamento Online': false,
          'Pagamento Ato': false,
          'Coleta em Domicílio': false
        },
        tiposOrcamento: [
          {
            title: 'Exames Laboratoriais',
            description: 'Para exames laboratoriais como exames de sangue,hemograma,glicose entre outros',
            name: 'Laboratórial',
            id: 'LABORATORIO'
          },
          {
            title: 'Exames de imagem',
            description: 'Para exames de imagem, como ressonancia magnética,raio x, ultrassonografia e outros',
            name: 'Imagem',
            id: 'CLINICA DE IMAGEM'
          },
          {
            title: 'Exames de Imagem e/ou Laboratoriais',
            description: 'Caso tenha exames de imagem ou laboratoriais',
            name: 'Imagem ou Laboratoriais',
            id: 'AMBOS'
          }
        ]
      }
    },

    watch: {
      nomeExameSearch: _.debounce(function (nomeExame) {
        this.$store.dispatch('getExames', {idRede: this.unidade._id, name: nomeExame})
          .then(listExame => {
            this.exames = listExame.filter(e => !this.filtroExames.find(ex => e._id === ex._id))
          })
      }, 150)/* ,
       nomeUnidadeSearch: _.debounce(function (nomeUnidade) {
        this.loadUnidades()
      }, 150) */
    },

    methods: {
      scrollMeTo (refName) {
        var element = this.$refs[refName]
        var top = element.offsetTop

        window.scrollTo(0, top)
      },
      loadUnidades (place) {
        this.unidade = null
        this.unidadeSelected = null
        this.filtroExames = []
        let query = {}
        query['uf__regex'] = `/${this.makeslug(this.$store.getters.uf)}/ig`
        if (this.$store.getters.cidade) {
          query['cidade__regex'] = `/${this.makeslug(this.$store.getters.cidade)}/ig`
        }
        if (this.$store.getters.bairro) {
          query['bairro__regex'] = `/${this.makeslug(this.$store.getters.bairro)}/ig`
        }
        query['nomeRede__regex'] = `/.*${''}.*/ig`
        if (this.tipoOrcamento) {
          query['tipoRede__in'] = this.tipoOrcamento.id === 'AMBOS' ? 'LABORATORIO,CLINICA DE IMAGEM' : this.tipoOrcamento.id
        } else {
          query['tipoRede__in'] = 'LABORATORIO,CLINICA DE IMAGEM'
        }
        query['status'] = 'HABILITADO'
        this.$store.dispatch('listRede', query)
          .then(listUnidades => {
            this.unidades = listUnidades
            this.unidadesSelect = this.limitUnidade(listUnidades)
          })
      },
      limitUnidade (listUnidade) {
        let values = []
        listUnidade.forEach((unidade) => {
          if (!values.find(un => unidade.codigoRede === un.codigoRede)) {
            values.push(unidade)
          }
        })
        return values
      },
      removeWhiteSpace (value) {
        return value.replace(/\s+/g, '-')
      },
      makeslug (val, replaceBy) {
        if (!val) return null
        replaceBy = replaceBy || '-'
        let mapaAcentosHex = { // by @marioluan and @lelotnk
          a: /[\xE0-\xE6]/g,
          A: /[\xC0-\xC6]/g,
          e: /[\xE8-\xEB]/g, // if you're gonna echo this
          E: /[\xC8-\xCB]/g, // JS code through PHP, do
          i: /[\xEC-\xEF]/g, // not forget to escape these
          I: /[\xCC-\xCF]/g, // backslashes (\), by repeating
          o: /[\xF2-\xF6]/g, // them (\\)
          O: /[\xD2-\xD6]/g,
          u: /[\xF9-\xFC]/g,
          U: /[\xD9-\xDC]/g,
          c: /\xE7/g,
          C: /\xC7/g,
          n: /\xF1/g,
          N: /\xD1/g
        }
        for (var letra in mapaAcentosHex) {
          let expressaoRegular = mapaAcentosHex[letra]
          val = val.replace(expressaoRegular, letra)
        }

        return val
      },
      textoExame (exame) {
        if (exame) {
          const nomeExame = exame.nomeExame
          if (nomeExame.length > 15) {
            return nomeExame.substr(0, 15) + '...'
          } else {
            return nomeExame
          }
        }
      },
      containsType (element, pTypes) {
        const types = pTypes.split(',')

        for (const findType in types) {
          if (element.types.indexOf(types[findType]) > -1) {
            return true
          }
        }
        return false
      },
      getTipoEndereco (place, type, format) {
        var addressComponent = place.address_components
        for (let i = 0; i < addressComponent.length; i++) {
          const element = addressComponent[i]
          if (this.containsType(element, type)) {
            if (format) {
              return element[format]
            } else {
              return element.long_name
            }
          }
        }
      },
      addExame (exame) {
        if (exame) {
          this.filtroExames.push(exame)
          this.$refs.laboratorioTh.inputValue = ''
          this.exames = []
          this.exame = null
          this.nomeExameSearch = ''
        } else if (this.exame) {
          this.filtroExames.push(this.exame)
          this.$refs.laboratorioTh.inputValue = ''
          this.exames = []
          this.exame = null
          this.nomeExameSearch = ''
        }
      },
      busca () {
        this.page = 1
        let filtro = {
          exames: this.filtroExames.map(exame => exame.codigoExame).toString().replace(/\[\]/g),
          bairro: this.makeslug(this.$store.getters.bairro),
          cidade: this.makeslug(this.$store.getters.cidade),
          uf: this.makeslug(this.$store.getters.uf)
        }
        if (this.unidade && this.nomeUnidadeSearch !== '') {
          filtro.idRede = this.unidade._id
        }

        if (this.outroServico['Agendamento']) {
          filtro.agendamento = true
        }
        if (this.outroServico['Pagamento Online']) {
          filtro.pagamentoOnline = true
        }

        if (this.outroServico['Coleta em Domicílio']) {
          filtro.coletaDomiciliar = true
        }

        if (this.outroServico['Pagamento Ato']) {
          filtro.pagamentoUnidade = true
        }

        this.$store.dispatch('findOrcamento', filtro)
          .then(() => {
            this.unidade = null
            this.nomeUnidadeSearch = ''
          })
      },
      showRede (rede) {
        return `${rede.nomeRede}`
      },
      handlePage (pageNum) {
        this.page = pageNum
        this.$store.dispatch('handlePagination', {page: this.page, pageSize: this.pageSize})
      },
      handleSort () {
        let field = ''
        let order = 'asc'
        if (this.ordenacao === 'Prestador') {
          field = 'rede.nomeRede'
          order = 'asc'
        }
        if (this.ordenacao === 'Preco') {
          field = 'subTotalSinSaude'
          order = 'asc'
        }
        if (this.ordenacao === 'MaiorPreco') {
          field = 'subTotalSinSaude'
          order = 'desc'
        }
        if (this.ordenacao === 'MelhorAvaliacao') {
          field = 'rate'
          order = 'desc'
        }

        this.$store.dispatch('handleSortOrcamento', {page: this.page, field, order})
      },
      limparOutros () {
        this.outroServico = {
          'Agendamento': false,
          'Delivery': false,
          'Pagamento Online': false,
          'Pagamento Ato': false,
          'Coleta em Domicílio': false
        }
      },
      findByServicos () {},
      showModalUnidades (ub) {
        this.unidadeSelected = ub
        this.unidade = null
        this.filtroExames = []
        const codigoRede = this.unidadeSelected.codigoRede
        const bairro = this.$store.getters.bairro
        const cidade = this.$store.getters.cidade
        this.unidadesEndereco = this.unidades
          .filter(un => un.codigoRede)
          .filter(un => un.codigoRede === codigoRede)
          .filter(un => {
            if (bairro) {
              return this.makeslug(un.bairro.toLowerCase()) === this.makeslug(bairro.toLowerCase()) &&
                this.makeslug(un.cidade.toLowerCase()) === this.makeslug(cidade.toLowerCase())
            }
            return this.makeslug(un.cidade.toLowerCase()) === this.makeslug(cidade.toLowerCase())
          })
        this.$nextTick(() => {
          this.scrollMeTo('unidadeEndereco')
        })
      },
      getEndereco (unidade) {
        return `${unidade.localAtendimento}, número ${unidade.numero}, ${unidade.bairro}, ${unidade.cidade} - ${unidade.uf}`
      },
      escolherRede (unidade) {
        this.unidade = unidade
        this.$nextTick(() => {
          this.scrollMeTo('unidadeExame')
          window.jQuery('#modalUnidadeEndereco').modal('hide')
        })
      },
      btnCompra () {
        window.jQuery('#onboardingFeaturesModal').modal('show')
      },
      comprar () {
        window.jQuery('#onboardingFeaturesModal').modal('hide')
        this.$router.push({name: 'Single',
          query: this.queryParam,
          params: {
            nomeRede: this.removeWhiteSpace(this.unidadeSelected.nomeRede),
            servico: 'Exame',
            descricao: this.removeWhiteSpace(this.filtroExames[0].nomeExame),
            cidade: this.removeWhiteSpace(this.unidadeSelected.cidade),
            preco: this.filtroExames[0].valorSinSaude ? this.filtroExames[0].valorSinSaude.toFixed(2) : null
          }})
      },
      async escolherTipoOrcamento (vl) {
        this.$store.dispatch('setTipoOrcamento', vl)
        const redes = await this.$store.dispatch('loadUnidadePorCartaoEtipoExame', vl.id)
        if (redes && redes.length > 0) {
          this.unidades = redes
          this.unidadeSelected = redes[0]
          this.unidadesEndereco = redes
        }
      }
    }
  }
</script>
<style scoped>
.list-controls {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 10px 20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: #ffffff;
}
.list-info {
    color: rgba(0, 0, 0, 0.4);
    font-size: 0.72rem;
    text-transform: uppercase;
    font-weight: 500;
    letter-spacing: 1px;
    font-size: 0.72rem;
}

.list-order {
    margin-left: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/orcamento/OrcamentoPage.vue